<template>
	<div class="online-test flex start-v">
		<div v-if="testList?.length===0" class="nodata-page" data-msg="暂时没有发布测试哦~"></div>
		<div v-bottom="nextPage" class="list">
			<Card v-for="(item,index) in testList" :key="index" :testInfo="item" />
			<div v-if="endPage" class="scroll-end"></div>
		</div>
	</div>
</template>

<script>
import Card from "./child/card.vue";
export default {
	components: {
		Card,
	},

	data() {
		return {
			params: {
				teamId: undefined,
				pageNo: 1,
				pageSize: 10,
			},
			testList: [],
			pages:0,
		};
	},

	mounted() {
		this.params.teamId = this.$route.query.gradeId;
		this.getTestList();
	},

	computed:{
		endPage(){
			return this.pages&&this.pages==this.params.pageNo;
		}
	},

	methods: {
		toCreate() {
			this.$router.push("/student/course/grade/onlinetest/create");
		},
		nextPage(){
			if(this.endPage) return;
			this.params.pageNo++;
			this.getTestList();
			console.log('nextPage');
		},
		async getTestList() {
			try {
				let {success,message,result} = await this.$http.get('h5/examineTest/list',{params:this.params})
				if(!success) throw new Error(message);
				this.pages = result.pages;
				this.testList = this.testList.concat(result.records);
			} catch (error) {
				console.log("getRaceList", error);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.online-test {
	height: 100%;

	.list{
		width: 100%;
		flex: 1;
		overflow-y: auto;
	}
}
</style>
